import React from 'react';
import { Button, Image } from 'react-bootstrap';
import './Weel.css';
import options from '../options.json';


class Weel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinAngleStart: 17.2896, // Math.random() * 10 + 10,
      spinTimeTotal: 4000, // Math.random() * 3 + 4 * 1000,
      // spinAngleStart: 15, // Math.random() * 10 + 10,
      // spinTimeTotal: 4000, //Math.random() * 3 + 4 * 1000,
      startAngle: 0,
      spinTime: 0,
      arc: Math.PI / (options.length / 2),
      text: "",
      winNumber: null,
      winNumberLine: null,
      winNumberColor: null,
      winNumberBefore: null,
      winNumberBeforeLine: null,
      winNumberBeforeColor: null,
      winNumberAfter: null,
      winNumberAfterLine: null,
      winNumberAfterColor: null,
      showResults: false,
      
      
    }

    const screenWidth = window.innerWidth;
    if (screenWidth >= 3000) {
      this.baseSize = 300 * 2.8;  
      this.baseSizeBtn = 200 * 2.8;
    } else if (screenWidth >= 2900) {
      this.baseSize = 300 * 2.7;  
      this.baseSizeBtn = 200 * 2.7;
    } else if (screenWidth >= 2800) {
      this.baseSize = 300 * 2.6;  
      this.baseSizeBtn = 200 * 2.6;
    } else if (screenWidth >= 2700) {
      this.baseSize = 300 * 2.5;  
      this.baseSizeBtn = 200 * 2.5;
    } else if (screenWidth >= 2600) {
      this.baseSize = 300 * 2.4;  
      this.baseSizeBtn = 200 * 2.4;
    } else if (screenWidth >= 2500) {
      this.baseSize = 300 * 2.3;  
      this.baseSizeBtn = 200 * 2.3;
    } else if (screenWidth >= 2400) {
      this.baseSize = 300 * 2.2;  
      this.baseSizeBtn = 200 * 2.2;
    } else if (screenWidth >= 2300) {
      this.baseSize = 300 * 2.1;  
      this.baseSizeBtn = 200 * 2.1;
    } else if (screenWidth >= 2200) {
      this.baseSize = 300 * 2;  
      this.baseSizeBtn = 200 * 2;
    } else if (screenWidth >= 2100) {
      this.baseSize = 300 * 1.9;  
      this.baseSizeBtn = 200 * 1.9;
    } else if (screenWidth >= 2000) {
      this.baseSize = 300 * 1.8;  
      this.baseSizeBtn = 200 * 1.8;
    } else if (screenWidth >= 1900) {
      this.baseSize = 300 * 1.7;  
      this.baseSizeBtn = 200 * 1.7;
    } else if (screenWidth >= 1800) {
      this.baseSize = 300 * 1.6;  
      this.baseSizeBtn = 200 * 1.6;
    } else if (screenWidth >= 1700) {
      this.baseSize = 300 * 1.5;  
      this.baseSizeBtn = 200 * 1.5;
    } else if (screenWidth >= 1600) {
      this.baseSize = 300 * 1.4;  
      this.baseSizeBtn = 200 * 1.4;
    } else if (screenWidth >= 1600) {
      this.baseSize = 300 * 1.3;  
      this.baseSizeBtn = 200 * 1.3;
    } else if (screenWidth >= 1500) {
      this.baseSize = 300 * 1.2;  
      this.baseSizeBtn = 200 * 1.2;
    } else if (screenWidth >= 1400) {
        this.baseSize = 300 * 1.1;  
        this.baseSizeBtn = 200 * 1.1;
    } else {
        this.baseSize = 300; // Default size
        this.baseSizeMin = 200;
        this.baseSizeBtn = 200;
    }


    this.spinTimer = null;
    // this.baseSize = 300;
    // this.baseSizeBtn = 200;
    this.handleOnClick = this.handleOnClick.bind(this);
    this.spin = this.spin.bind(this);
    this.rotate = this.rotate.bind(this);
    // console.log(this.state.arc);
  }

  

  componentDidMount() {
    // this.setState({ startAngle: 0, spinAngleStart: 15, spinTimeTotal: 4000 });
    this.drawRouletteWheel();
    this.drawRouletteWheel2();
  }
  // componentDidMount() {
  //   this.drawRouletteWheel();
  // }

  componentWillUnmount() {
    this.stopRotateWheel()
  }


  // componentDidMount() {
  //   const screenWidth = window.innerWidth;
  //   if (screenWidth >= 1400) {
  //     this.baseSize = 300 * 1.2; // Increase by 20%
  //     this.baseSizeBtn = 200 * 1.2;
  //   } else {
  //     this.baseSize = 300; // Default size
  //     this.baseSizeBtn = 200;
  //   }
  //   this.drawRouletteWheel();
  //   console.log(screenWidth);
  // } 


 

  drawRouletteWheel() {
    const canvas = this.refs.canvas;
    const ctx = canvas.getContext('2d');

    const scale = window.devicePixelRatio || 1;
    const baseSize = this.baseSize; 
    const adjustedSize = baseSize * scale;

 
    canvas.width = adjustedSize * 2;
    canvas.height = adjustedSize * 2;
    canvas.style.width = `${baseSize * 2}px`;
    canvas.style.height = `${baseSize * 2}px`;
    ctx.scale(scale, scale);

    const outsideRadius = baseSize - 25;
    const textRadius = baseSize - 45;
    const insideRadius = baseSize - 105;

    ctx.font = `${14 * scale}px Helvetica, Arial`;

    for (let i = 0; i < options.length; i++) {
        const angle = this.state.startAngle + i * this.state.arc;
        ctx.fillStyle = options[i].color;
        ctx.beginPath();
        ctx.arc(baseSize, baseSize, outsideRadius, angle, angle + this.state.arc, false);
        ctx.arc(baseSize, baseSize, insideRadius, angle + this.state.arc, angle, true);
        ctx.fill();
        // const gradient = ctx.createLinearGradient(
        //     baseSize + Math.cos(angle) * outsideRadius,
        //     baseSize + Math.sin(angle) * outsideRadius,
        //     baseSize + Math.cos(angle + this.state.arc) * outsideRadius,
        //     baseSize + Math.sin(angle + this.state.arc) * outsideRadius
        // );
        // gradient.addColorStop(0, options[i].line);
        // gradient.addColorStop(1, options[i].line);

        // line border

        // ctx.lineWidth = 0 * scale;
        // ctx.strokeStyle = gradient;
        // ctx.beginPath();
        // ctx.arc(baseSize, baseSize, outsideRadius, angle, angle + this.state.arc, false);
        // ctx.stroke();
        ctx.save();
        ctx.fillStyle = 'white';
        // Move and rotate to desired position
        ctx.translate(
            baseSize + Math.cos(angle + this.state.arc / 2) * textRadius,
            baseSize + Math.sin(angle + this.state.arc / 2) * textRadius
        );
        ctx.rotate(angle + this.state.arc / 2 + Math.PI / 2);
        // Align the text so its bottom edge sits on y = 0
        ctx.textBaseline = 'bottom';
        // Draw the text
        const text = options[i].number;
        ctx.fillText(text, -ctx.measureText(text).width / 2, 27);
        ctx.restore();
    }



        // Arrow
        ctx.strokeStyle = 'yellow';
        ctx.lineWidth = 2 * scale;
        ctx.fillStyle = 'red';
        ctx.beginPath();
        ctx.moveTo(baseSize + 10, baseSize - (outsideRadius + 20));
        ctx.lineTo(baseSize + 0, baseSize - (outsideRadius - 5));
        ctx.lineTo(baseSize - 10, baseSize - (outsideRadius + 20));
        ctx.fill();
        ctx.stroke();

        // Square with border
   
    }


    drawRouletteWheel2() {
      const canvas2 = this.refs.canvas2;
      const ctx = canvas2.getContext('2d');
      const scale = window.devicePixelRatio || 1;
      const baseSize = this.baseSize / 1.2; 
      console.log(baseSize);
      const adjustedSize = baseSize * scale;
      canvas2.width = adjustedSize * 2;
      canvas2.height = adjustedSize * 2;
      canvas2.style.width = `${baseSize * 2}px`;
      canvas2.style.height = `${baseSize * 2}px`;
      ctx.scale(scale, scale);
      const outsideRadius = baseSize - 25;
      const textRadius = baseSize - 45;
      const insideRadius = baseSize - 105;
   
  
      for (let i = 0; i < options.length; i++) {
          const angle = this.state.startAngle + i * this.state.arc;
          ctx.fillStyle = options[i].color;
          ctx.beginPath();
          ctx.arc(baseSize, baseSize, outsideRadius, angle, angle + this.state.arc, false);
          ctx.arc(baseSize, baseSize, insideRadius, angle + this.state.arc, angle, true);
          ctx.fill();
 
          ctx.save();
          ctx.fillStyle = 'white';
          // Move and rotate to desired position
          ctx.translate(
              baseSize + Math.cos(angle + this.state.arc / 2) * textRadius,
              baseSize + Math.sin(angle + this.state.arc / 2) * textRadius
          );
          ctx.rotate(angle + this.state.arc / 2 + Math.PI / 2);
          // Align the text so its bottom edge sits on y = 0
          ctx.textBaseline = 'bottom';

          // Add border with silver color
          ctx.strokeStyle = 'silver';
          ctx.lineWidth = 3;
          ctx.stroke();
    
  
          ctx.restore();
      }
    }

    



  spin(winNumber = null) {
    // const curSpinAngleStart = winNumber ? options.find(o => o.number === winNumber).angle : 17.2896;
    // this.setState({ startAngle: 0, spinAngleStart: curSpinAngleStart, spinTimeTotal: 4000  }, () => this.rotate());
    this.spinTimer = null;

    const curSpinAngleStart = winNumber ? options.find(o => o.number === winNumber)?.angle : 17.2896;
    this.setState({ spinTime: 0, startAngle: 0, spinAngleStart: curSpinAngleStart, spinTimeTotal: 4000  }, () => this.rotate());
  }

  rotate() {
    const { spinAngleStart, spinTime, startAngle, spinTimeTotal } = this.state;
    if (spinTime > 2800) {
      clearTimeout(this.spinTimer);
      this.stopRotateWheel();
    } else {
      const spinAngle = spinAngleStart - this.easeOut(spinTime, 0, spinAngleStart, spinTimeTotal);
      // console.log('startAngle spinTime', spinTimeTotal, startAngle, spinAngle, spinAngleStart, spinTime);
      // console.log(this.state.arc);
      this.setState({
        startAngle: startAngle + spinAngle * Math.PI / 180,
        spinTime: spinTime + 10,
      }, () => {
        this.drawRouletteWheel();
        this.drawRouletteWheel2();
        clearTimeout(this.spinTimer);
        this.spinTimer = setTimeout(() => this.rotate(), 30);
      })
    }
  }

  stopRotateWheel() {
    let { startAngle, arc } = this.state;
    const canvas = this.refs.canvas;
    const ctx = canvas.getContext('2d');
    const degrees = startAngle * 180 / Math.PI + 90;
    const arcd = arc * 180 / Math.PI;
    const index = Math.floor((360 - degrees % 360) / arcd);
    // console.log(degrees);
    // console.log(arcd);
    // console.log(index);
    ctx.save();
    const text = options[index].number;
    this.setState({ text })
    ctx.restore();
    this.props.updateNum(this.state.text);

    // const prevIndex = (index - 1 + options.length) % options.length;
    // const nextIndex = (index + 1) % options.length;

  this.setState({ 
    // winNumber: options[index].number,
    // winNumberLine: options[index].line,
    // winNumberColor: options[index].color,
    // winNumberBefore: options[prevIndex].number,
    // winNumberBeforeLine: options[prevIndex].line,
    // winNumberBeforeColor: options[prevIndex].color,
    // winNumberAfter: options[nextIndex].number,
    // winNumberAfterLine: options[nextIndex].line,
    // winNumberAfterColor: options[nextIndex].color,
    showResults: true 
  });

  setTimeout(() => {
    this.setState({ showResults: false });
  }, 5000);


 

  }


 


  easeOut(t, b, c, d) {
    const ts = (t /= d) * t;
    const tc = ts * t;
    return b + c * (tc + -3 * ts + 3 * t);
  }

  // handleOnClick(winNumber = null) {
  //   this.spin(winNumber);
  //   this.props.isSpinning(true)
  // }

  handleOnClick(winNumber) {
    const stringValNumber = typeof winNumber === 'string' ? winNumber : "17";
    this.spin(stringValNumber);
    this.props.isSpinning(true)
  }

  

  SpinButton() {

    return (
      <div>
        <input type="button" value="spin" className="btn btn-primary p-2 m-2" id="spin" /> 
        {/* onClick={this.handleOnClick} /> */}
      </div>
    );

  }

  renderNumber = () => {
    return (
      <h1 className="blinky-number display-4 pt-1 m-0 text-big">{this.state.text}</h1>
      
    )
  }
  renderBtnText = () => {
    const btnText = this.state.spinTime > 0 ? 'No More Bets!' : 'Put your bets and spin the wheel!';
    if (this.state.text !== "") {
      return (
        <div>
          {this.renderNumber()}
        </div>
      )
    } else {
      return (<h6 className="blink text-uppercase m-0 text-bigger">{btnText}</h6>)
    }
  }

 

  render() { 
 
  

    return (
      <React.Fragment>

        <div className={`roulette-container  align-self-start  ${this.state.showResults ? 'show-results-roulette' : ''}`} style={{
                width: `${this.baseSize * 2}px`,
                height: `${this.baseSize * 2}px`
              }}>
          {/* <div className={`roulette-win ${this.state.showResults ? 'show-results' : ''}`}>
            <div className="arrow"></div>
            <div className="roulette-win__item-pol"
            style={{
              background: `${this.state.winNumberBeforeColor}`
            }}
            >
              <div className="roulette-win__item-line"
              style={{
                background: `${this.state.winNumberBeforeLine}`
              }}
              ></div>
                {this.state.winNumberBefore}
            </div>
            <div className="roulette-win__item" 
            style={{
                background: `${this.state.winNumberColor}`
              }}
            >
              <div className="roulette-win__item-line"
              style={{
                background: `${this.state.winNumberLine}`
              }}
              ></div> 
              {this.state.winNumber}
            </div>
            <div className="roulette-win__item-pol"
            style={{
              background: `${this.state.winNumberAfterColor}`
            }}
            >
              <div className="roulette-win__item-line"
              style={{
                background: `${this.state.winNumberAfterLine}`
              }}
              ></div> 
                {this.state.winNumberAfter}
            </div>
          </div> */}
          <canvas ref="canvas" width={this.baseSize * 2} height={this.baseSize * 2} className="roulette-canvas"></canvas>
          <canvas 
          ref="canvas2" 
          width={this.baseSize * 2} 
          height={this.baseSize * 2} 
          className="roulette-canvas2" 
          style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
          ></canvas>
          {this.props.arr.length !== 0 ?
            <Button
              // onClick={this.handleOnClick} 
              style={{
                width: `${this.baseSizeBtn * 2}px`,
                height: `${this.baseSizeBtn * 2}px`
              }}
              className="spin-button"
              size="lg"
              block variant="danger">
              <h5 className="blink text-uppercase m-0">Spin the wheel!</h5>
            </Button>
            :
            <Button
            style={{
              width: `${this.baseSizeBtn * 1.5}px`,
              height: `${this.baseSizeBtn * 1.5}px`,
              // marginLeft: `-${this.baseSizeBtn}px`,
              // marginTop: `-${this.baseSizeBtn}px`,
              position: 'absolute', 
              top: '50%', 
              left: '50%', 
              transform: 'translate(-50%, -50%)', 
              margin: '0',
            }}

            // ref={(el) => {
            //   if (el) { 
            //     el.style.setProperty('margin-left', `-${this.baseSizeBtn / 2}px`, 'important');
            //     el.style.setProperty('margin-top', `-${this.baseSizeBtn / 2}px`, 'important');
            //   }
            // }}
              className="spin-button text-big"
              size="lg"
              block variant="dark">
              {this.renderBtnText()}
            </Button>

          }
        </div>
      </React.Fragment>

    );
  }
}


export default Weel;
